if(Object.values===undefined) {
    Object.values = o => Object.keys(o).map(k=>o[k]);
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}



// WEBPACK FOOTER //
// ./src/utils/polyfills.js